// A Sales Count team is named after its head: the CRM whose reporting chain it is ("ANITA" -> "ANITA team"). The data keeps the
// head's name (crmUserName); this is how it is shown, on the results and on the threshold screen, so both read the same.
export const teamLabel = (headName) => {
  const name = String(headName ?? '').trim();
  return name ? `${name} team` : null;
};

export default teamLabel;
